import { Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import CompDatePicker from '../../components/compDatePicker/_CompDatePicker';
import { AgentModel, CustomerModel, ElementaryInsurancePolicyModel, ElementaryPolicyModel, IDNameDescriptionItem, Policy, PolicyBaseModel, PolicyModel, PolicyType, Vehicle, VehicleDataModel } from '../../models/superbit-api-models';
import { IDNameDescriptionDictionary } from '../../models/Site';
import { PolicyModel as policyModelApi } from '../../models/PolicyModel';
import { IDNameDescriptionItemSelect } from '../../components/_IDNameDescriptionItemSelect';
import PolicyInput from '../../components/_PolicyInput';
import { SimulatorModel } from '../../models/SimulatorModel';
import './_ClientPolicyEdit.css';
import CheckBox from '../../components/_CheckBox';
import { GeneralDataModel } from '../../models/GeneralDataModel';
import { cloneDeep, set } from 'lodash';
import { on } from 'events';
import { GetBanks } from '../../models/CacheModel';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../app-context/store';
import { setNewPolicyWithAdditionNumber } from '../../app-context/clientsSlice';
import { start } from 'repl';
import MessegePopupClient from '../_MessegePopupClient';
import HouseDetails from './HouseDetails';
import BusinessDetails from './BusinessDetails';
import PaymentAndBankDetails from './PaymentAndBankDetails';
import DriversDetails from './DriversDetails';

interface TransformedBankData {
    BankName: string;
    branchCode: number[];
}

interface ErrorsDictionary {
    field: string;
    message: string;
}

type Props = {
    ShowHidePopup: Function;
    ClosePopup?: Function;
    OnApprove?: Function;
    type: string;
    messageTitle?: string;
    customerId: string;
    customerData: any;
    policyTypesObj: any;
    policiesList: any[];
};


const ClientPolicyEditPopup = (props: Props) => {

    const policyModel: policyModelApi = new policyModelApi();
    const dispatch = useDispatch();
    const newPolicyWithAdditionNumber = useSelector((state: RootState) => state.clientsSlice.newPolicyWithAdditionNumber);

    const [popUpTitle, setPopUpTitle] = useState<string>(props.messageTitle ? props.messageTitle : 'צור חדש / עדכן')

    const [policy, setPolicy] = useState<any>(new PolicyModel());
    const [edit, setEdit] = useState(false);
    const [insuranceCompanies, setInsuranceCompanies] = useState<IDNameDescriptionDictionary>({});
    const [licenseNumberLoading, setLicenseNumberLoading] = useState<boolean>(false);
    const [authorizedToDrive, setAuthorizedToDrive] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [genders, setGenders] = useState<any[]>([]);

    const [authorizedToDriveSelected, setAuthorizedToDriveSelected] = useState<number>(0);

    const [ageYoungDriver, setAgeYoungDriver] = useState<number>(0);
    const [driverYoungSeniority, setDriverYoungSeniority] = useState<number>(0);

    const [ageMainDriver, setAgeMainDriver] = useState<number>(0);
    const [driverMainSeniority, setDriverMainSeniority] = useState<number>(0);

    const [vehicleOwnership, setVehicleOwnership] = useState<IDNameDescriptionDictionary>({});
    const [passedTypeOfInsurance, setPassedTypeOfInsurance] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [policyTypes, setPolicyTypes] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [collectionMethodtype, setCollectionMethodType] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [eventTypes, setEventTypes] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());

    const [branchesList, setBranchesList] = useState<any[]>([]);
    const [policyChoosenId, setPolicyChoosenId] = useState<string>('');
    const [allBanks, setAllBanks] = useState<any[]>([]);

    const [isAdditionalNumberPolicy, setIsAdditionalNumberPolicy] = useState<boolean>(false);
    const [showPopUp, setShowPopUp] = useState<boolean>(false);

    const [validationErrors, setValidationErrors] = useState<ErrorsDictionary[]>([]);



    const loadDataForIDNameDescriptionDictionarys = async () => {
        const authorizedToDriveStorage = localStorage.getItem('authorizedToDrive');
        if (authorizedToDriveStorage) {
            const parsedAuthorizedToDrive = JSON.parse(authorizedToDriveStorage);
            if (parsedAuthorizedToDrive) {
                console.log('storage-client-policy-details authorizedToDrive')
                setAuthorizedToDrive({ "-1": { id: -1, name: "בחר", description: "בחר נהג" }, ...parsedAuthorizedToDrive });
            }
        } else {
            let authorizedToDrive = await new SimulatorModel().getAuthorizedToDriveItems();
            if (authorizedToDrive) {
                localStorage.setItem('authorizedToDrive', JSON.stringify(authorizedToDrive));
                setAuthorizedToDrive({ "-1": { id: -1, name: "בחר", description: "בחר נהג" }, ...authorizedToDrive });

            }
        }

        new SimulatorModel().getGenderTypes().then((res: any) => {
            const gendersList: any = [];
            Object.keys(res).forEach((key: string) => {
                const gender = res[key];
                gendersList.push({
                    label: gender.description,
                    value: gender.id.toString()
                })
            })
            setGenders(gendersList);
        })

        const passedTypeOfInsuranceStorage = localStorage.getItem('passedTypeOfInsurance');
        if (passedTypeOfInsuranceStorage) {
            const parsedPassedTypeOfInsurance = JSON.parse(passedTypeOfInsuranceStorage);
            if (parsedPassedTypeOfInsurance) {
                setPassedTypeOfInsurance(parsedPassedTypeOfInsurance);
            }
        } else {
            let passedTypeOfInsurance = await new SimulatorModel().getPassedTypeOfInsurance();
            if (passedTypeOfInsurance) {
                localStorage.setItem('passedTypeOfInsurance', JSON.stringify(passedTypeOfInsurance));
                setPassedTypeOfInsurance(passedTypeOfInsurance);
            }
        }

        const policyTypesStorage = localStorage.getItem('policyTypes');
        if (policyTypesStorage) {
            const parsedPolicyTypes = JSON.parse(policyTypesStorage);
            if (parsedPolicyTypes) {
                setPolicyTypes(parsedPolicyTypes);
            }
        } else {
            let policyTypes = await new GeneralDataModel().getAppDictionaryListExpanded();
            if (policyTypes) {
                localStorage.setItem('policyTypes', JSON.stringify(policyTypes));
                setPolicyTypes(policyTypes);
            }
        }

        const collectionMethodTypeStorage = localStorage.getItem('collectionMethodType');
        if (collectionMethodTypeStorage) {
            const parsedCollectionMethodType = JSON.parse(collectionMethodTypeStorage);
            if (parsedCollectionMethodType) {
                setCollectionMethodType(parsedCollectionMethodType);
            }
        } else {
            let collectionMethodtype = await new SimulatorModel().getCollectionMethodTypes();
            if (collectionMethodtype) {
                localStorage.setItem('collectionMethodType', JSON.stringify(collectionMethodtype));
                setCollectionMethodType(collectionMethodtype);
            }
        }

        const eventTypesStorage = localStorage.getItem('eventTypes');
        if (eventTypesStorage) {
            const parsedEventTypes = JSON.parse(eventTypesStorage);
            if (parsedEventTypes) {
                console.log('storage-client-policy-details eventTypes')
                setEventTypes(parsedEventTypes);
            }
        } else {
            let eventTypes = await new SimulatorModel().getEventTypes();
            if (eventTypes) {
                localStorage.setItem('eventTypes', JSON.stringify(eventTypes));
                setEventTypes(eventTypes);
            }
        }


        setVehicleOwnership(await new SimulatorModel().getVehicleOwnership());

    }

    const loadAllBank = async () => {
        const bankDict: Record<string, number[]> = {};
        const allBanksData = await GetBanks();
        console.log('allBanksData', allBanksData)
        allBanksData.forEach((item) => {
            const { Bank_Name, Branch_Code, Branch_Address, Branch_Name } = item;
            if (!bankDict[Bank_Name]) {
                bankDict[Bank_Name] = [];
            }
            bankDict[Bank_Name].push({ 'Branch_Code': Branch_Code, 'Branch_Address': Branch_Address + " " + Branch_Name } as any);
        });
        const transformedData: TransformedBankData[] = Object.entries(bankDict).map(
            ([BankName, branchCodes]) => {
                branchCodes = (branchCodes as any).sort((a: any, b: any) => a.Branch_Code - b.Branch_Code);
                return {
                    BankName,
                    branchCode: branchCodes,
                };
            }
        );
        setAllBanks(transformedData);
    }

    const init = async () => {
        console.log('ClientPolicyEditPopup init props.type', props.type);
        const newPolicy = { ...policy } as PolicyModel;
        newPolicy.customerId = props.customerId;
        newPolicy.customer = props.customerData;
        newPolicy.policyType = new PolicyType();
        newPolicy.additionNumber = "00";
        newPolicy.policyAdditionDetails = new PolicyBaseModel();
        newPolicy.policyAdditionDetails.elementaryPolicy = undefined;
        newPolicy.policyAdditionDetails.fullName = props.customerData.fullName;
        newPolicy.policyType.policyTypeId = props.type ? parseInt(props.type) : 0;
        newPolicy.policyAdditionDetails.vehicle = new Vehicle();
        newPolicy.policyAdditionDetails.paymentDetails = ["", "", "", "", "", ""];
        newPolicy.startDate = new Date();
        newPolicy.extensionStartDate = new Date();

        const user = localStorage.getItem('loggedUser');
        if (user) {
            const userdata = JSON.parse(user);
            newPolicy.creatorUserId = userdata.id;
            newPolicy.userId = userdata.id;
            newPolicy.agentId = userdata.agentId
        }


        setPolicy(newPolicy);
        const loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            const userdata = JSON.parse(loggedUser);
            const agentsStorage = localStorage.getItem('agents');
            if (agentsStorage) {
                const agents = JSON.parse(agentsStorage);
                const agent = agents.find((a: any) => a.id === userdata.agentId);
                if (agent) {
                    newPolicy.agent = {
                        id: agent.id,
                        createdDate: agent.createdDate,
                        updatedDate: agent.updatedDate,
                        name: agent.name
                    } as AgentModel;
                }
            }
        }

        loadDataForIDNameDescriptionDictionarys();
        loadAllBank();

        setPolicy(newPolicy);

        console.log('ClientPolicyEditPopup init newPolicy', newPolicy);
    }

    const onAdditionalDetailsChangeRoute = (value: any) => {
        console.log(`onAdditionalDetailsChangeRoute details route changed to ${value}`, typeof value);
        const selectedRoute = branchesList.find((route: any) => route.routeId === value || route.compulsoryRouteId === value);
        console.log('onAdditionalDetailsChangeRoute-selectedRoute', selectedRoute);
        if (selectedRoute) {
            setPolicy((prevPolicy: any) => ({
                ...prevPolicy,
                policyAdditionDetails: {
                    ...prevPolicy.policyAdditionDetails,
                    route: {
                        routeId: selectedRoute.routeId,
                        compulsoryRouteId: selectedRoute.compulsoryRouteId,
                        comment: selectedRoute.comment,
                        id: selectedRoute.id,
                        agentId: selectedRoute.agentId,
                        containsRider: selectedRoute.containsRider,
                        specificDetails: selectedRoute.specificDetails,
                        status: selectedRoute.status,
                        temsAndCovers: selectedRoute.temsAndCovers,
                        temsAndCoversFile: selectedRoute.temsAndCoversFile,
                        temsAndCoversFilePath: selectedRoute.temsAndCoversFilePath
                    },
                    routeId: selectedRoute.id
                }
            }))
        }
    }

    const onChangeStartDate = (date: Date | null) => {
        console.log('onChangeStartDate-date', date);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            extensionStartDate: date
            // startDate: date
        }));

        if (isAdditionalNumberPolicy) {

        } else {
            const calculatedEndDate = getCalcEndDateByStartDate(date as Date);
            setPolicy((prevPolicy: any) => ({
                ...prevPolicy,
                extensionEndDate: calculatedEndDate
                // endDate: calculatedEndDate
            }));
        }

    }

    const getCalcEndDateByStartDate = (startDate: Date) => {
        // 
        if (startDate != null) {
            var month = startDate.getMonth();
            var year = startDate.getFullYear();
            if (startDate.getDate() > 15) {
                month++;
                if (month == 13) {
                    month = 1;
                    year++;
                }

            }
            var endDate = new Date(year + 1, month, 1, 0, 0, 0, 0);
            endDate.setDate(endDate.getDate() - 1);
            return endDate;

        }
        return new Date();
    }

    const createDataListOfBranches = async (insuranceCompanyId: string = '', policyType: number, type: number) => {
        setBranchesList([]);

        if (!policy || !policy) {
            return;
        }

        let branches: any[] = [];
        try {
            branches = await policyModel.policyGetRoutesByConditions({
                insuranceCompanyId: policy && policy.insuranceCompanyId ? policy.insuranceCompanyId : insuranceCompanyId,
                policyTypeId: Number(type),
                vehiclePolicyType: Number(policyType)
            });
        } catch (error) {
            console.error('createDataListOfBranches-error', error);
        }
        if(policyType == 6 && branches.length > 0 ){
            let arr = []
            arr.push(branches[0]);
            setBranchesList(arr as any[]);
        } else {
            setBranchesList(branches);
        }
        // setBranchesList(branches);
    }


    const getInsuranceCompanies = () => {
        const insuranceCompaniesData = localStorage.getItem('insuranceCompanies');
        if (!insuranceCompaniesData) {
            return {};
        }

        const companies = JSON.parse(insuranceCompaniesData);
        if (!companies || !Array.isArray(companies) || companies.length === 0) {
            return {};
        }

        let dictionary = new IDNameDescriptionDictionary();
        const _key = 0;
        dictionary[_key] = new IDNameDescriptionItem();
        dictionary[_key].id = 0;
        dictionary[_key].name = "בחר חברה";
        dictionary[_key].description = "בחר חברה";
        companies.forEach((company: any, index: number) => {
            let newData = new IDNameDescriptionItem({ id: company.value, name: company.label, description: company.label });
            dictionary[index + 1] = newData;
        });
        setInsuranceCompanies(dictionary);
    }


    useEffect(() => {
        if (newPolicyWithAdditionNumber.policyId && newPolicyWithAdditionNumber.policyId.length > 0
            && newPolicyWithAdditionNumber.additionNumber && newPolicyWithAdditionNumber.additionNumber.length > 0
        ) {

            setIsAdditionalNumberPolicy(true);
            copyDataFromExistingPolicy(newPolicyWithAdditionNumber.policyId, newPolicyWithAdditionNumber.additionNumber);
        } else {
            init()
        }
        getInsuranceCompanies();
    }, []);

    const copyDataFromExistingPolicy = async (policyId: string, additionNumber: string = '') => {

        await loadDataForIDNameDescriptionDictionarys();
        await loadAllBank();

        console.log('Selected policy to copy from:', policyId);
        setPolicyChoosenId(policyId);
        const selectedPolicy = props.policiesList.find((p: any) => p.id === policyId);
        if (selectedPolicy) {
            try {
                const res = await policyModel.getElementaryInsurancePolicyId(selectedPolicy.policyAdditionDetails.id);
                console.log('copyDataFromExistingPolicy-res', res)
                const newPolicy = { ...selectedPolicy }
                newPolicy.id = undefined;
                newPolicy.policyAdditionDetails = cloneDeep(res);
                newPolicy.startDate = new Date();
                newPolicy.endDate = res.policy.endDate;
                newPolicy.extensionStartDate = new Date();
                newPolicy.extensionEndDate = new Date(res.policy.endDate);
                newPolicy.eventDate = new Date();
                const user = localStorage.getItem('loggedUser');
                if (user) {
                    const userdata = JSON.parse(user);
                    newPolicy.creatorUserId = userdata.id;
                }
                if (additionNumber && additionNumber.length > 0) {
                    console.log('copyDataFromExistingPolicy-additionNumber', '0' + additionNumber)
                    newPolicy.additionNumber = '0' + additionNumber;
                    newPolicy.policyAdditionDetails.eventType = 3; // set to 3 (תוספת פוליסה)
                }
                await createDataListOfBranches(newPolicy.insuranceCompanyId, 0, parseInt(props.type));

                setPolicy(newPolicy);
                // setPolicy(selectedPolicy);
            } catch (error) {
                console.error('error', error);
            }
        }
    }

    const onInsuranceCompanyChange = (field: string, value: any) => {
        // Handle insurance company change logic here
        console.log(`Insurance company field ${field} changed to ${value}`);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            insuranceCompanyId: value

        }));
    }


    const closePopup = (status?: string) => {
        console.log('ClientPolicyEditPopup closePopup');
        if (props.ClosePopup) {
            props.ClosePopup(status);
        } else {
            if (props.ShowHidePopup) {
                props.ShowHidePopup(status)
            }
        }
        dispatch(setNewPolicyWithAdditionNumber({ policyId: '', additionNumber: '' }));
    }

    const isAllFieldsValid = (): boolean => {
        
        let errors: ErrorsDictionary[] = [];
        // Add validation logic here

        if (!policy.policyNumber || policy.policyNumber.trim() === '') {
            errors.push({ field: 'policyNumber', message: 'חובה להזין מספר פוליסה' });
        }
        if (!policy.insuranceCompanyId || policy.insuranceCompanyId === undefined || policy.insuranceCompanyId === 0) {
            errors.push({ field: 'insuranceCompanyId', message: 'חובה לבחור חברת ביטוח' });
        }
        if (policy.policyAdditionDetails.vehiclePolicyType === undefined || policy.policyAdditionDetails.vehiclePolicyType === -1 ) {
            errors.push({ field: 'vehiclePolicyType', message: 'חובה לבחור סוג פוליסה' });
        }
        if (!policy.policyAdditionDetails.route || !policy.policyAdditionDetails.route.id) {
            errors.push({ field: 'routeId', message: 'חובה לבחור ענף' });
        }

        if (!policy.policyAdditionDetails.vehicle || !policy.policyAdditionDetails.vehicle.licenseNumber || policy.policyAdditionDetails.vehicle.licenseNumber.trim() === '') {
            errors.push({ field: 'licenseNumber', message: 'חובה להזין מספר רישוי' });
        }
        if (!policy.extensionStartDate) {
            errors.push({ field: 'extensionStartDate', message: 'חובה לבחור תאריך התחלה' });
        }
        if (!policy.extensionEndDate) {
            errors.push({ field: 'extensionEndDate', message: 'חובה לבחור תאריך סיום' });
        }
        if(!policy.eventDate) {
            errors.push({ field: 'eventDate', message: 'חובה לבחור תאריך אירוע' });
        }

        if (!policy.policyAdditionDetails.driversType || policy.policyAdditionDetails.driversType === -1 || policy.policyAdditionDetails.driversType === undefined) {
            errors.push({ field: 'driversType', message: 'חובה לבחור סוג נהגים' });
        }
        if (policy.policyAdditionDetails.driversType > 0) {
            if (authorizedToDriveSelected < 2) {
                if (
                    (!policy.policyAdditionDetails.driverYoungFirstName && !policy.policyAdditionDetails.driverYoungLastName  || policy.policyAdditionDetails.driverYoungFirstName.trim() === '' && policy.policyAdditionDetails.driverYoungLastName.trim() === '')) {
                    errors.push({ field: 'youngDriverName', message: 'חובה להזין שם לנהג צעיר' });
                }
                if (
                    (!policy.policyAdditionDetails.driverYoungIdentifier || policy.policyAdditionDetails.driverYoungIdentifier.trim() === '')) {
                    errors.push({ field: 'youngDriverId', message: 'חובה להזין ת.ז. לנהג צעיר' });
                }
                if (
                    policy.policyAdditionDetails.driverYoungGender === undefined) {
                    errors.push({ field: 'youngDriverGender', message: 'חובה לבחור מין לנהג צעיר' });
                }
            }
            if(
                policy.policyAdditionDetails.driverYoungBirthDate === null || policy.policyAdditionDetails.driverYoungBirthDate === undefined) {
                errors.push({ field: 'youngDriverDOB', message: 'חובה לבחור תאריך לנהג צעיר' });
            }
            if(
                policy.policyAdditionDetails.driverYoungSeniorityDate === null || policy.policyAdditionDetails.driverYoungSeniorityDate === undefined) {
                errors.push({ field: 'youngDriverLicenseIssueDate', message: 'חובה לבחור תאריך הוצאת רישיון לנהג צעיר' });
            }

        }
        if (policy.policyAdditionDetails.driversType  >= 0 && policy.policyAdditionDetails.driversType < 2) {
            if (
                (!policy.policyAdditionDetails.driverMainFirstName && !policy.policyAdditionDetails.driverMainLastName || policy.policyAdditionDetails.driverMainFirstName.trim() === '' &&  policy.policyAdditionDetails.driverMainLastName.trim() === '')) {
                errors.push({ field: 'mainDriverName', message: 'חובה להזין שם לנהג ראשי' });
            }
            if (
                (!policy.policyAdditionDetails.driverMainIdentifier || policy.policyAdditionDetails.driverMainIdentifier.trim() === '')) {
                errors.push({ field: 'mainDriverId', message: 'חובה להזין ת.ז. לנהג ראשי' });
            }
            if (
                policy.policyAdditionDetails.driverMainGender === undefined) {
                errors.push({ field: 'mainDriverGender', message: 'חובה לבחור מין לנהג ראשי' });
            }
            if(
                (policy.policyAdditionDetails.driverMainBirthDate === null || policy.policyAdditionDetails.driverMainBirthDate === undefined)) {
                errors.push({ field: 'mainDriverDOB', message: 'חובה לבחור תאריך לנהג ראשי' });
            }
            if(
                (policy.policyAdditionDetails.driverMainSeniorityDate === null || policy.policyAdditionDetails.driverMainSeniorityDate === undefined)) {
                errors.push({ field: 'mainDriverLicenseIssueDate', message: 'חובה לבחור תאריך הוצאת רישיון לנהג ראשי' });
            }
        }
        if(!policy.policyAdditionDetails.premiumSum || policy.policyAdditionDetails.premiumSum === undefined || policy.policyAdditionDetails.premiumSum <= 0) {
            errors.push({ field: 'premiumSum', message: 'חובה להזין סכום פרמיה' });
        }
        setValidationErrors(errors);
        if (errors.length > 0) {
            return false;
        }
        return true;
    }

    const savePolicy = async () => {
        if(!isAllFieldsValid()) {
            return;
        }
        console.log('savePolicy-policy', policy);
        let policyToSave = { ...policy };
        // policyToSave.insuranceCompany = undefined;
        // policyToSave.route = undefined;
        policyToSave.salesperson = undefined;
        policyToSave.polcyType = undefined; // need to get id of type
        policyToSave.user = undefined;
        policyToSave.creatorUser = undefined;

        // passing of all data in policyAdditionDetails.vehicle and evrything that is undifined replaced to null
        policyToSave.policyAdditionDetails.vehicle = JSON.parse(JSON.stringify(policyToSave.policyAdditionDetails.vehicle, (key, value) => {
            if (key === 'airBags' || key === 'gearsType' || key === 'id' || key === 'usePurposesType' || key === 'vehicleValue' || key === 'vehicleWeight') {
                return value;
            }
            if (key === 'manufacturer') {
                return null;
            }
            return value === undefined ? null : value;
        }));
        // passing of all data in policyAdditionDetails.route and evrything that is undifined replaced to null
        policyToSave.policyAdditionDetails.route = JSON.parse(JSON.stringify(policyToSave.policyAdditionDetails.route, (key, value) => {
            return value === undefined ? null : value;
        }));
        policyToSave.id = undefined;
        policyToSave.policyAdditionDetails.eventDate = new Date();

        try {
            const res = await policyModel.policyCreate(policyToSave);
            console.log('savePolicy-res', res)
        } catch (error) {
            console.error('savePolicy-error', error);
        } finally {
            closePopup('saved');
            dispatch(setNewPolicyWithAdditionNumber({ policyId: '', additionNumber: '' }));
            setShowPopUp(true);
        }
    }

    const onVehicleChange = (field: string, value: any) => {
        setPolicy((prev: any) => {
            const newPolicy = { ...prev };
            if (newPolicy && newPolicy.policy && newPolicy.policyAdditionDetails && !newPolicy.policyAdditionDetails.vehicle) {
                newPolicy.policyAdditionDetails.vehicle = new Vehicle();
            }
            (newPolicy.policyAdditionDetails.vehicle as any)[field] = value;
            return newPolicy;
        });
    }

    const getVehicleDetails = async (event: any) => {
        event.preventDefault();
        var _licenseNumber = event.currentTarget.value.trim();

        if (_licenseNumber.length > 0) {
            setLicenseNumberLoading(true);
            // const _vehicle: VehicleDetailsData = new VehicleDetailsData();
            var data = await new SimulatorModel().getVehicleDetailsByLicenseNumber(_licenseNumber);
            console.log('getVehicleDetails-data', data)
            // 
            if (data && data.LeviItzhak) {
                setPolicy((prev: any) => {
                    const newPolicy = { ...prev };
                    if (newPolicy && newPolicy.policy && newPolicy.policy.policyAdditionDetails && !newPolicy.policy.policyAdditionDetails.vehicle) {
                        newPolicy.policy.policyAdditionDetails.vehicle = new Vehicle();
                    }
                    if (!data || !data.LeviItzhak) {
                        return newPolicy;
                    }
                    newPolicy.policyAdditionDetails.vehicle.licenseNumber = _licenseNumber;
                    newPolicy.policyAdditionDetails.vehicle.modelCode = data && data.LeviItzhak.vehicleSubModel && data.LeviItzhak.vehicleSubModel.code ?
                        data.LeviItzhak.vehicleSubModel.code : '';
                    newPolicy.policyAdditionDetails.vehicle.modelName = data.LeviItzhak.carYear;
                    newPolicy.policyAdditionDetails.vehicle.carYear = data && data.LeviItzhak.carYear ? data.LeviItzhak.carYear : '';
                    newPolicy.policyAdditionDetails.vehicle.esp = data && data.LeviItzhak.esp ? data.LeviItzhak.esp : '';
                    newPolicy.policyAdditionDetails.vehicle.fcw = data && data.LeviItzhak.fcw ? data.LeviItzhak.fcw : '';
                    newPolicy.policyAdditionDetails.vehicle.ldw = data && data.LeviItzhak.ldw ? data.LeviItzhak.ldw : '';
                    newPolicy.policyAdditionDetails.vehicle.entryToRoadDate = data && data.LeviItzhak.entryToRoad ? new Date(data.LeviItzhak.entryToRoad) : undefined;
                    newPolicy.policyAdditionDetails.vehicle.vehicleSubModelId = data && data.LeviItzhak.vehicleSubModel && data.LeviItzhak.vehicleSubModel.val ?
                        data.LeviItzhak.vehicleSubModel.val : '';
                    newPolicy.policyAdditionDetails.vehicle.vehicleSubModel = data.LeviItzhak.vehicleSubModel;
                    newPolicy.policyAdditionDetails.vehicle.vehicleModel = data && data.LeviItzhak.vehicleModel ? data.LeviItzhak.vehicleModel as any : undefined;
                    newPolicy.policyAdditionDetails.vehicle.manufacturer = data && data.LeviItzhak.manufacturer ? data.LeviItzhak.manufacturer as any : undefined;
                    newPolicy.policyAdditionDetails.vehicle.vehicleOwnership = data && data.LeviItzhak && data.LeviItzhak.vehicleOwnership ? data.LeviItzhak.vehicleOwnership :
                        data.LeviItzhak.vehicleOwnership !== undefined ? data.LeviItzhak.vehicleOwnership : 0;
                    console.log('data.LeviItzhak.vehicleOwnership', data)
                    return newPolicy;
                });
            }
            setLicenseNumberLoading(false);
        }
    }

    const onChangePrimeryDetails = (field: string, value: any) => {
        // Handle primary details change logic here
        console.log(`Primary details field ${field} changed to ${value}`);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            [field]: value

        }));
    }


    const onAdditionalDetailsChange = (field: string, value: any) => {
        // Handle additional details change logic here
        console.log(`Additional details field ${field} changed to ${value}`);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                [field]: field == 'numberOfPayments' ? Number(value) : value
            }
        }));
    }

    const onAdditionalDetailsChangeInsuranceType = async (field: string, value: any) => {
        // Handle additional details change logic here
        console.log(`onAdditionalDetailsChangeInsuranceType details field ${field} changed to ${value}`, typeof value);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                vehiclePolicyType: Number(value),
                route: undefined,
                routeId: undefined
            }
        }));
        createDataListOfBranches('', value, props.type ? parseInt(props.type) : 0);
    };

    const onChangeAuthorizedToDrive = (field: string, value: any) => {
        // Handle authorized to drive change logic here
        console.log(`Authorized to drive changed to ${value}`);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                driversType: Number(value)
            }

        }));

        setAuthorizedToDriveSelected(Number(value));
    };

    // const onChangeDriverDetails = (e: any, type: string) => {
    //     const { name, value } = e.target;
    //     console.log(`Driver details field ${name} changed to ${value}`);
    //     console.log('Driver details field policy ', policy);

    //     if (type === 'young') {
    //         setPolicy((prevPolicy: any) => ({
    //             ...prevPolicy,
    //             policyAdditionDetails: {
    //                 ...prevPolicy.policyAdditionDetails,
    //                 youngDriverCustomer: {
    //                     ...prevPolicy.policyAdditionDetails.youngDriverCustomer,
    //                     [name]: value
    //                 }
    //             }

    //         }));

    //     } else if (type === 'main') {
    //         setPolicy((prevPolicy: any) => ({
    //             ...prevPolicy,
    //             policyAdditionDetails: {
    //                 ...prevPolicy.policyAdditionDetails,
    //                 mainDriverCustomer: {
    //                     ...prevPolicy.policyAdditionDetails.mainDriverCustomer,
    //                     [name]: value
    //                 }
    //             }

    //         }));
    //     }
    // }

    const onChangeDriverDetails = (e: any) => {
        const { name, value } = e.target;
        console.log(`Driver details field ${name} changed to ${value}`);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                [name]: value
            }
        }));
    }

    // const onChangeDriverYoungGenderDetails = (value: string) => {
    //     setPolicy((prevPolicy: any) => ({
    //         ...prevPolicy,
    //         policyAdditionDetails: {
    //             ...prevPolicy.policyAdditionDetails,
    //             youngDriverCustomer: {
    //                 ...prevPolicy.policyAdditionDetails.youngDriverCustomer,
    //                 gender: Number(value)
    //             }

    //         }
    //     }));
    // }

    const onChangeDriverYoungGenderDetails = (value: string) => {
         setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                driverYoungGender: Number(value)
            }
        }));
    }

    // const onChangeDriverMainGenderDetails = (value: string) => {
    //     setPolicy((prevPolicy: any) => ({
    //         ...prevPolicy,
    //         policyAdditionDetails: {
    //             ...prevPolicy.policyAdditionDetails,
    //             mainDriverCustomer: {
    //                 ...prevPolicy.policyAdditionDetails.mainDriverCustomer,
    //                 gender: Number(value)
    //             }
    //         }

    //     }));
    // }

    const onChangeDriverMainGenderDetails = (value: string) => {
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                driverMainGender: Number(value)
            }
        }));
    }

    // young driver customer

    // const onYoungDriverCustomerAgeChange = (field: string, value: Date) => {
    //     // Handle additional young driver customer details change logic here
    //     console.log(`Additional young driver customer field ${field} changed to ${value}`);
    //     const newPolicyItem = { ...policy };
    //     if (newPolicyItem) {
    //         // Update the policy state with the new age value
    //         const additionDetails = newPolicyItem.policyAdditionDetails || new PolicyBaseModel();
    //         if (!additionDetails.youngDriverCustomer) {
    //             additionDetails.youngDriverCustomer = new CustomerModel();
    //         }
    //         // Directly assign to dateOfBirth since this function is specifically for that field
    //         additionDetails.youngDriverCustomer.dateOfBirth = value;
    //         // newPolicyItem.policy.policyAdditionDetails = additionDetails;
    //         // Update the policy state


    //         setPolicy((prevPolicy: any) => ({
    //             ...prevPolicy,
    //             policyAdditionDetails: additionDetails

    //         }));
    //         setAgeYoungDriver(getAge(value));
    //     }
    // }

    const onYoungDriverCustomerAgeChange = (field: string, value: Date) => {        

        // Handle additional young driver customer details change logic here
        console.log(`Additional young driver customer field ${field} changed to ${value}`);
        const newPolicy = { ...policy };
        // Update the policy state with the new age value
        const additionDetails = newPolicy.policyAdditionDetails || {};

        additionDetails[field] = value
        newPolicy.policyAdditionDetails = additionDetails;
        // Update the policy state
         setPolicy((prevPolicy: any) => ({
                ...prevPolicy,
                policyAdditionDetails: additionDetails

            }));
            setAgeYoungDriver(getAge(value));

    }


    // const onYoungDriverCustomerSeniorityChange = (field: string, date: Date) => {
    //     // Handle additional young driver customer details change logic here
    //     console.log(`Additional young driver customer field ${field} changed to ${date}`);
    //     const newPolicyItem = { ...policy };
    //     if (newPolicyItem) {
    //         // Update the policy state with the new age value
    //         const additionDetails = newPolicyItem.policyAdditionDetails || new PolicyBaseModel();
    //         if (!additionDetails.youngDriverCustomer) {
    //             additionDetails.youngDriverCustomer = new CustomerModel();
    //         }
    //         // Directly assign to dateOfBirth since this function is specifically for that field
    //         additionDetails.youngDriverCustomer.driverLicensIssueDate = date;
    //         // newPolicyItem.policy.policyAdditionDetails = additionDetails;
    //         // Update the policy state
    //         setPolicy((prevPolicy: any) => ({
    //             ...prevPolicy,
    //             policyAdditionDetails: additionDetails

    //         }));
    //         setDriverYoungSeniority(getAge(date));
    //     }
    // }

    const onYoungDriverCustomerSeniorityChange = (field: string, date: Date) => {
            // Handle additional young driver customer details change logic here
            console.log(`Additional young driver customer field ${field} changed to ${date}`);
            const newPolicyItem = { ...policy };
            if (newPolicyItem) {
                // Update the policy state with the new age value
                const additionDetails = newPolicyItem.policyAdditionDetails || new PolicyBaseModel();
                
                // Directly assign to dateOfBirth since this function is specifically for that field
                additionDetails.driverYoungSeniorityDate = date;
                // newPolicyItem.policy.policyAdditionDetails = additionDetails;
                // Update the policy state
                setPolicy((prevPolicy: any) => ({
                    ...prevPolicy,
                    policyAdditionDetails: additionDetails
    
                }));
                setDriverYoungSeniority(getAge(date));
            }
        }
    


    // senior main driver


    // const onMainDriverCustomerAgeChange = (field: string, date: Date) => {
    //     // Handle additional young driver customer details change logic here
    //     console.log(`Additional main driver customer field ${field} changed to ${date}`);
    //     const newPolicyItem = { ...policy };
    //     if (newPolicyItem) {
    //         // Update the policy state with the new age value
    //         const additionDetails = newPolicyItem.policyAdditionDetails || new PolicyBaseModel();
    //         if (!additionDetails.mainDriverCustomer) {
    //             additionDetails.mainDriverCustomer = new CustomerModel();
    //         }
    //         // Directly assign to dateOfBirth since this function is specifically for that field
    //         additionDetails.mainDriverCustomer.dateOfBirth = date;
    //         // newPolicyItem.policy.policyAdditionDetails = additionDetails;
    //         // Update the policy state
    //         setPolicy((prevPolicy: any) => ({
    //             ...prevPolicy,
    //             policyAdditionDetails: additionDetails

    //         }));
    //         setAgeMainDriver(getAge(date));
    //     }
    // }

    const onMainDriverCustomerAgeChange = (field: string, date: Date) => {
            // Handle additional young driver customer details change logic here
            console.log(`Additional main driver customer field ${field} changed to ${date}`);
            const newPolicyItem = { ...policy };
            if (newPolicyItem) {
                // Update the policy state with the new age value
                const additionDetails = newPolicyItem.policyAdditionDetails || new PolicyBaseModel();
                
                // Directly assign to dateOfBirth since this function is specifically for that field
                additionDetails.driverMainBirthDate = date;
                // newPolicyItem.policy.policyAdditionDetails = additionDetails;
                // Update the policy state
                setPolicy((prevPolicy: any) => ({
                    ...prevPolicy,
                    policyAdditionDetails: additionDetails
    
                }));
                setAgeMainDriver(getAge(date));
            }
        }
    

    // const onMainDriverCustomerSeniorityChange = (field: string, date: Date) => {
    //     // Handle additional young driver customer details change logic here
    //     console.log(`Additional main driver customer field ${field} changed to ${date}`);
    //     const newPolicyItem = { ...policy };
    //     if (newPolicyItem) {
    //         // Update the policy state with the new age value
    //         const additionDetails = newPolicyItem.policyAdditionDetails || new PolicyBaseModel();
    //         if (!additionDetails.mainDriverCustomer) {
    //             additionDetails.mainDriverCustomer = new CustomerModel();
    //         }
    //         // Directly assign to dateOfBirth since this function is specifically for that field
    //         additionDetails.mainDriverCustomer.driverLicensIssueDate = date;
    //         // newPolicyItem.policy.policyAdditionDetails = additionDetails;
    //         // Update the policy state
    //         setPolicy((prevPolicy: any) => ({
    //             ...prevPolicy,
    //             policyAdditionDetails: additionDetails

    //         }));
    //         setDriverMainSeniority(getAge(date));
    //     }
    // }

    const onMainDriverCustomerSeniorityChange = (field: string, date: Date) => {
            // Handle additional young driver customer details change logic here
            console.log(`Additional main driver customer field ${field} changed to ${date}`);
            const newPolicyItem = { ...policy };
            if (newPolicyItem) {
                // Update the policy state with the new age value
                const additionDetails = newPolicyItem.policyAdditionDetails || new PolicyBaseModel();
                
                // Directly assign to dateOfBirth since this function is specifically for that field
                additionDetails.driverMainSeniorityDate = date;
                // newPolicyItem.policy.policyAdditionDetails = additionDetails;
                // Update the policy state
                setPolicy((prevPolicy: any) => ({
                    ...prevPolicy,
                    policyAdditionDetails: additionDetails
    
                }));
                setDriverMainSeniority(getAge(date));
            }
        }
    


    const getAge = (date: any) => {
        // Handle additional young driver customer details change logic here
        if (date) {
            const dateOfBirth = new Date(date);
            const today = new Date();
            let age = today.getFullYear() - dateOfBirth.getFullYear();
            const m = today.getMonth() - dateOfBirth.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < dateOfBirth.getDate())) {
                age--;
            }
            return age;
        }
        return 0;
    }

    const setPremia = (e: any) => {
        let value = e.target.value;
        if (!isNaN(Number(value))) {
            // value is a number
            setPolicy((prevPolicy: any) => ({
                ...prevPolicy,
                policyAdditionDetails: {
                    ...prevPolicy.policyAdditionDetails,
                    premiumSum: Number(value)
                }
            }));
        }
    };



    // const onChangeCCNumberDetails = (field: string, value: any) => {
    //     // Handle credit card details change logic here
    //     console.log(`Credit card details field ${field} changed to ${value}`);

    //     setPolicy((prevPolicy: any) => {
    //         const newPolicy = { ...prevPolicy };
    //         if (!newPolicy.policyAdditionDetails.elementaryPolicy) {
    //             newPolicy.policyAdditionDetails.elementaryPolicy = new ElementaryPolicyModel();
    //         }
    //         if (!newPolicy.policyAdditionDetails.elementaryPolicy.compulsoryPaymentDetails) {
    //             newPolicy.policyAdditionDetails.elementaryPolicy.compulsoryPaymentDetails = [];
    //         }
    //         if (newPolicy.policyAdditionDetails.elementaryPolicy.compulsoryPaymentDetails.length === 0) {
    //             newPolicy.policyAdditionDetails.elementaryPolicy.compulsoryPaymentDetails.push(value);
    //         } else {
    //             newPolicy.policyAdditionDetails.elementaryPolicy.compulsoryPaymentDetails[0] = value;
    //         }
    //         return newPolicy;
    //     });
    // }

    const getCreatorIfo = (creatorUserId: string) => {
        const users = localStorage.getItem('usersList');
        if (!users) {
            return '';
        }
        const usersList = JSON.parse(users);
        if (!usersList || !Array.isArray(usersList) || usersList.length === 0) {
            return '';
        }
        const creatorUser = usersList.find((user: any) => user.id === creatorUserId);
        if (!creatorUser) {
            return '';
        }
        if (creatorUser.fullName && creatorUser.fullName.length > 0) {
            return creatorUser.fullName;
        }
        return creatorUserId ? creatorUserId : '';
    }

    const getRouteInfo = (branch: any) =>{
        if(policy.policyAdditionDetails.vehiclePolicyType == 6){
            return branch.compulsoryRouteId;
        } else {
            return branch.routeId;
        }
    }


    const emptyFunc = () => { }

    return (
        <>
            {
                showPopUp &&
                <MessegePopupClient
                    onClose={() => setShowPopUp(false)}
                />
            }
            <div className={`popup-wrapper edit-policy-popup ${props.type}`}>
                <section className="popup-window rtl">
                    <div className="close-icon pointer" onClick={(e: any) => closePopup()}></div>
                    <div className="popup-content">
                        <div className="popup-header">
                            <div className="popup-title">
                                {/* {popUpTitle} */}
                                פרטי הפוליסה ({props.type})
                            </div>
                        </div>
                        {policy && policy.policyAdditionDetails &&
                            <div className="popup-body">
                                <div className="row-items">
                                    <div className="item">

                                        <div className="title">
                                            העתקה מפוליסה קיימת
                                        </div>
                                        <Select
                                            disabled={isAdditionalNumberPolicy}
                                            value={''}
                                            onChange={(value: any) => copyDataFromExistingPolicy(value)}
                                            style={{ width: '170px', height: '30px' }}
                                        >
                                            <option value=''>בחר פוליסה</option>
                                            {props.policiesList && props.policiesList.length > 0 && props.policiesList.map((policyItem: any) => (
                                                <option
                                                    key={policyItem.id}
                                                    value={policyItem.id}
                                                >
                                                    {policyItem.policyNumber}
                                                </option>
                                            ))}

                                        </Select>

                                    </div>
                                </div>
                                <div className="row-items">
                                    <div className="item">
                                        <div className="title">
                                            שם מבוטח
                                        </div>
                                        <PolicyInput
                                            type='text'
                                            value={props.customerData.fullName}
                                            disabled={true}
                                            onChange={emptyFunc}
                                        />
                                        <div className='error-message'>
                                            {/* *{this.state.errors.requiredField} */}
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="title">
                                            סוג אירוע
                                        </div>

                                        <IDNameDescriptionItemSelect
                                            OnChange={onAdditionalDetailsChange}
                                            Options={eventTypes}
                                            Id={"eventType"}
                                            Value={policy.policyAdditionDetails && policy.policyAdditionDetails.eventType ? policy.policyAdditionDetails.eventType : ''}
                                        />
                                    </div>

                                    <div className="item">
                                        <div className="title">
                                            מספר פוליסה
                                        </div>

                                        <PolicyInput
                                            disabled={isAdditionalNumberPolicy}
                                            type='text'
                                            value={policy && policy.policyNumber ? policy.policyNumber : ''}
                                            onChange={(e: any) => {
                                                setPolicy((prev: any) => {
                                                    const newPolicy = { ...prev };
                                                    newPolicy.policyNumber = e.target.value;
                                                    return newPolicy;
                                                });
                                            }}
                                        />
                                        <div className='error-message'>
                                            {validationErrors.find(err => err.field === 'policyNumber') &&
                                                <span>
                                                    *{validationErrors.find(err => err.field === 'policyNumber')?.message}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="title">
                                            מס' תוספת
                                        </div>
                                        <PolicyInput
                                            disabled={isAdditionalNumberPolicy}
                                            type='text'
                                            value={policy && policy.additionNumber ? policy.additionNumber : ''}
                                            onChange={(e: any) => {
                                                setPolicy((prev: any) => {
                                                    const newPolicy = { ...prev };
                                                    newPolicy.additionNumber = e.target.value;
                                                    return newPolicy;
                                                });
                                            }}
                                        />
                                        <div className='error-message'>
                                            {/* *{this.state.errors.requiredField} */}
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="title">
                                            חברת ביטוח
                                        </div>
                                        <IDNameDescriptionItemSelect
                                            Disabled={isAdditionalNumberPolicy}
                                            OnChange={onInsuranceCompanyChange}
                                            Options={insuranceCompanies}
                                            Id={"insuranceCompanyId"}
                                            Value={policy && policy.insuranceCompanyId}
                                        />
                                        <div className='error-message'>
                                            {validationErrors.find(err => err.field === 'insuranceCompanyId') &&
                                                <span>
                                                    *{validationErrors.find(err => err.field === 'insuranceCompanyId')?.message}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                    <div className="cell">
                                        <div className="title">
                                            סוג ביטוח
                                        </div>
                                        <div className="description cell-value">
                                            <IDNameDescriptionItemSelect
                                                OnChange={onAdditionalDetailsChangeInsuranceType}
                                                Options={{
                                                    "-1": { id: -1, name: "בחר סוג ביטוח", description: "בחר סוג ביטוח" },
                                                    ...policyTypes
                                                }}
                                                Id={"vehiclePolicyType"}
                                                Value={ policy && policy.policyAdditionDetails && policy.policyAdditionDetails.vehiclePolicyType != undefined && policy.policyAdditionDetails.vehiclePolicyType >= 0
                                                    ? policy.policyAdditionDetails.vehiclePolicyType :"-1"}
                                            />
                                        </div>
                                        <div className='error-message'>
                                            {validationErrors.find(err => err.field === 'vehiclePolicyType') &&
                                                <span>
                                                    *{validationErrors.find(err => err.field === 'vehiclePolicyType')?.message}
                                                </span>
                                            }
                                        </div>
                                       
                                    </div>

                                    <div className="item">
                                        <div className="title">
                                            שם ענף
                                        </div>
                                        {/* <PolicyInput type='text' value={''} onChange={emptyFunc} /> */}
                                        <Select
                                            value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.route && policy.policyAdditionDetails.vehiclePolicyType == 6
                                                && policy.policyAdditionDetails.route.compulsoryRouteId ? policy.policyAdditionDetails.route.compulsoryRouteId : 
                                                policy.policyAdditionDetails.route && policy.policyAdditionDetails.route.routeId ? policy.policyAdditionDetails.route.routeId : ''}
                                            onChange={onAdditionalDetailsChangeRoute}
                                            style={{ width: '170px', height: '30px' }}
                                        >
                                            <option value=''>בחר ענף</option>
                                            {branchesList && branchesList.length > 0 && branchesList.map((branch: any) => (
                                                <option
                                                    key={branch.id}
                                                    value={policy.policyAdditionDetails.vehiclePolicyType == 6 ? branch.compulsoryRouteId : branch.routeId ? branch.routeId : ''}
                                                >
                                                {getRouteInfo(branch)}  - {branch.comment}
                                                {/* {branch.routeId ? branch.routeId : branch.compulsoryRouteId}  */}
                                               
                                                </option>
                                            ))}

                                        </Select>
                                        <div className='error-message'>
                                            {validationErrors.find(err => err.field === 'routeId') &&
                                                <span>
                                                    *{validationErrors.find(err => err.field === 'routeId')?.message}
                                                </span>
                                            }
                                        </div>
                                    </div>



                                </div>
                                <div className="row-items">
                                    <div className="item">
                                        <div className="title">
                                            תאריך אירוע
                                        </div>
                                        <CompDatePicker
                                            placeholder={'תאריך אירוע'}
                                            value={policy && policy.eventDate ? new Date(policy.eventDate) : null}
                                            onChange={(date: Date | null) => {
                                                setPolicy((prevPolicy: any) => ({
                                                    ...prevPolicy,
                                                    eventDate: date
                                                }));
                                            }}
                                        />

                                        <div className='error-message'>
                                            {validationErrors.find(err => err.field === 'eventDate') &&
                                                <span>
                                                    *{validationErrors.find(err => err.field === 'eventDate')?.message}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="title">
                                            מספר סוכן
                                        </div>
                                        <PolicyInput type='text' onChange={(e: any) => onAdditionalDetailsChange('agentNumber', e.target.value)}
                                            value={policy?.policyAdditionDetails?.agentNumber >= 0 ? policy.policyAdditionDetails.agentNumber : ''}
                                            disabled={true}
                                            style={{ marginLeft: '10px' }}
                                        />
                                        <div className='error-message'>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="title">
                                            חברה קודמת
                                        </div>
                                        <IDNameDescriptionItemSelect
                                            OnChange={(field: string, value: any) => onAdditionalDetailsChange('lastCompanyId', value)}
                                            Options={insuranceCompanies}
                                            Id={"lastCompanyId"}
                                            Value={policy.policyAdditionDetails && policy.policyAdditionDetails.lastCompanyId || 0}
                                        />
                                        <div className='error-message'>
                                            {/* *{this.state.errors.requiredField} */}
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="title">
                                            תאריך תחילה
                                        </div>
                                        <CompDatePicker
                                            placeholder={'תאריך תחילה'}
                                            value={policy && policy.extensionStartDate ? new Date(policy.extensionStartDate) : policy.startDate ? new Date(policy.startDate) : null}
                                            onChange={(date: Date | null) => {

                                                onChangeStartDate(date);
                                            }}
                                        />
                                        <div className='error-message'>
                                            {validationErrors.find(err => err.field === 'extensionStartDate') &&
                                                <span>
                                                    *{validationErrors.find(err => err.field === 'extensionStartDate')?.message}
                                                </span>
                                            }
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="title">
                                            תאריך סיום
                                        </div>
                                        <CompDatePicker
                                            placeholder={'תאריך סיום'}
                                            value={policy && policy.extensionEndDate ? new Date(policy.extensionEndDate) : policy.endDate ? new Date(policy.endDate) : null}
                                            onChange={(date: Date | null) => {
                                                setPolicy((prevPolicy: any) => ({
                                                    ...prevPolicy,
                                                    extensionEndDate: date

                                                }));
                                            }}
                                        />
                                        <div className='error-message'>
                                            {validationErrors.find(err => err.field === 'extensionEndDate') &&
                                                <span>
                                                    *{validationErrors.find(err => err.field === 'extensionEndDate')?.message}
                                                </span>
                                            }
                                        </div>
                                    </div>


                                </div>
                                <div className={`${props.type && (props.type == '1') ? '' : 'hide'}`}>
                                    <div className="row-items">
                                        <div className="tab-content-title section-title" style={{ marginTop: '20px', fontWeight: '600', padding: '5px 20px' }}>
                                            פרטי הרכב
                                        </div>
                                    </div>
                                    <div className="row-items">
                                        <div className="item">
                                            <div className="title">
                                                מספר רישוי
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <PolicyInput type='text'
                                                    value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle
                                                        && policy.policyAdditionDetails.vehicle.licenseNumber ? policy.policyAdditionDetails.vehicle.licenseNumber : ''}
                                                    onChange={(e) => onVehicleChange('licenseNumber', e.target.value)}
                                                    onBlur={(e: any) => getVehicleDetails(e)}
                                                    style={{ marginLeft: '10px' }}
                                                />
                                                <img src={require("../../assets/images/loading.gif")}
                                                    className={licenseNumberLoading ? "loadingGif" : "hide"} />

                                            </div>
                                            <div className='error-message'>
                                                { validationErrors.find(err => err.field === 'licenseNumber') &&
                                                    <span>
                                                        *{validationErrors.find(err => err.field === 'licenseNumber')?.message}
                                                    </span>
                                                }
                                            </div>
                                        </div>

                                        <div className="item">
                                            <div className="title">
                                                קוד דגם
                                            </div>
                                            <PolicyInput
                                                type='text'
                                                value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle
                                                    && policy.policyAdditionDetails.vehicle.modelCode ? policy.policyAdditionDetails.vehicle.modelCode : ''}
                                                onChange={(e) => onVehicleChange('modelCode', e.target.value)}
                                                style={{ marginLeft: '10px' }}
                                            // onBlur={(e: any) =>onBlurVehicleModelCode(e)}
                                            />
                                            <div className='error-message'>
                                                {/* *{this.state.errors.requiredField} */}
                                            </div>
                                        </div>
                                        <div className="item">
                                            <div className="title">
                                                שנת יצור
                                            </div>
                                            <PolicyInput
                                                type='number'
                                                value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle
                                                    && policy.policyAdditionDetails.vehicle.carYear ? policy.policyAdditionDetails.vehicle.carYear.toString() : ''}
                                                onChange={(e) => onVehicleChange('carYear', e.target.value)}
                                                disabled={true}
                                                style={{ marginLeft: '10px' }}
                                            />

                                        </div>
                                        <div className="item">
                                            <div className="title">
                                                דגם
                                            </div>
                                            <PolicyInput
                                                type='text'
                                                value={policy?.policyAdditionDetails?.vehicle?.vehicleSubModel?.label ? policy.policyAdditionDetails.vehicle.vehicleSubModel.label : ''}
                                                onChange={(e) => onVehicleChange('modelName', e.target.value)}
                                                disabled={true}
                                                style={{ marginLeft: '10px', width: '200px' }}
                                            />
                                            <div className='error-message'>
                                                {/* *{this.state.errors.requiredField} */}
                                            </div>
                                        </div>

                                        <div className="item">
                                            <div className="title">
                                                בעלות הרכב
                                            </div>
                                            <div className='value'>
                                                {policy && policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle
                                                    && policy.policyAdditionDetails.vehicle.vehicleOwnership != undefined && policy.policyAdditionDetails.vehicle.vehicleOwnership >= 0 &&
                                                    vehicleOwnership[policy.policyAdditionDetails.vehicle.vehicleOwnership]
                                                    && vehicleOwnership[policy.policyAdditionDetails.vehicle.vehicleOwnership].description ? vehicleOwnership[policy.policyAdditionDetails.vehicle.vehicleOwnership].description : ''}
                                            </div>
                                        </div>


                                    </div>
                                </div>
                                <div className={`${props.type && props.type == '1' ? '' : 'hide'}`}>
                                    <DriversDetails
                                        policy={policy}
                                        onAdditionalDetailsChange={onAdditionalDetailsChange}
                                        onChangeAuthorizedToDrive={onChangeAuthorizedToDrive}
                                        authorizedToDrive={authorizedToDrive}
                                        authorizedToDriveSelected={authorizedToDriveSelected}
                                        onChangeDriverDetails={onChangeDriverDetails}
                                        onChangeDriverYoungGenderDetails={onChangeDriverYoungGenderDetails}
                                        genders={genders}
                                        onYoungDriverCustomerAgeChange={onYoungDriverCustomerAgeChange}
                                        ageYoungDriver={ageYoungDriver}
                                        onYoungDriverCustomerSeniorityChange={onYoungDriverCustomerSeniorityChange}
                                        driverYoungSeniority={driverYoungSeniority}
                                        onChangeDriverMainGenderDetails={onChangeDriverMainGenderDetails}
                                        onMainDriverCustomerAgeChange={onMainDriverCustomerAgeChange}
                                        ageMainDriver={ageMainDriver}
                                        onMainDriverCustomerSeniorityChange={onMainDriverCustomerSeniorityChange}
                                        driverMainSeniority={driverMainSeniority}
                                        passedTypeOfInsurance={passedTypeOfInsurance}
                                    />

                                </div>
                                <div className={`${props.type && props.type == '20' ? '' : 'hide'}`}>
                                    <div className="row-items">
                                        <div className="item">
                                            <div className="
                                title">
                                                הכיסוי המבוקש
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row-items">
                                        <div className="item">
                                            <div className="title">
                                                סוג כיסוי
                                            </div>
                                            <div className="value">
                                                <Select
                                                    value={'NONE'}
                                                    style={{ width: '100%' }}
                                                    options={[
                                                        {
                                                            label: 'בחר סוג כיסוי',
                                                            value: 'NONE'
                                                        },
                                                        {
                                                            label: 'שמשות + רדיו + שירותי דרך + גרירה',
                                                            value: '1'
                                                        },
                                                        {
                                                            label: 'שמשות + רדיו + שירותי דרך + גרירה + רכב חליפי',
                                                            value: '2'
                                                        },
                                                        {
                                                            label: 'שירותי דרך + גרירה + רכב חליפי',
                                                            value: '3'
                                                        },
                                                        {
                                                            label: 'גרירה',
                                                            value: '4'
                                                        },
                                                        {
                                                            label: 'שמשות',
                                                            value: '5'
                                                        },
                                                        {
                                                            label: 'שמשות + גרירה',
                                                            value: '5'
                                                        },
                                                        {
                                                            label: 'גרירה לרכב אספנות',
                                                            value: '6'
                                                        },
                                                        {
                                                            label: 'תיקון מוצרי חשמל',
                                                            value: '7'
                                                        },
                                                        {
                                                            label: 'רכב חליפי',
                                                            value: '8'
                                                        },
                                                        {
                                                            label: 'אחר',
                                                            value: '9'
                                                        },
                                                    ]}
                                                />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                        <div className={`parameter-item`}>
                                            <div className="field">
                                                <div className="title">
                                                    שם  כיסוי
                                                </div>
                                                <div className="value">
                                                </div>
                                                <div className='error-message'>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`parameter-item`}>
                                            <div className="field">
                                                <div className="title">
                                                    סוג אירוע
                                                </div>
                                                <div className="value">
                                                    <Select
                                                        value={'NONE'}
                                                        style={{ width: '100%' }}
                                                        options={[
                                                            {
                                                                label: 'בחר סוג אירוע',
                                                                value: 'NONE'
                                                            },
                                                            {
                                                                label: 'פןליסה',
                                                                value: '1'
                                                            },
                                                            {
                                                                label: 'חידוש',
                                                                value: '2'
                                                            },
                                                            {
                                                                label: 'ביטול',
                                                                value: '3'
                                                            },
                                                            {
                                                                label: 'קיצור תקופה',
                                                                value: '4'
                                                            },
                                                            {
                                                                label: 'החלפת רכב',
                                                                value: '5'
                                                            },
                                                        ]}
                                                    />
                                                </div>
                                                <div className='error-message'>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${props.type && props.type == '2' ? '' : 'hide'}`}>
                                    <HouseDetails />

                                </div>
                                <div className={`${props.type && props.type == '3' ? '' : 'hide'}`}>
                                    <BusinessDetails />
                                </div>
                                <div className={`${props.type && props.type == '15' ? '' : 'hide'}`}>
                                    <div className="parameter-row">
                                        <div className="tab-content-title section-title">
                                            פרטי עובד
                                        </div>
                                    </div>
                                    <div className="parameter-row">
                                        <div className={`parameter-item`}>
                                            <div className="field">
                                                <div className="title">
                                                    ספק שירות
                                                </div>
                                                <div className="value">
                                                    <Select
                                                        value={'ספק שירות'}
                                                        style={{ width: '100%' }}
                                                        options={[
                                                            {
                                                                label: 'כללית',
                                                                value: '1'
                                                            },
                                                            {
                                                                label: 'פמי',
                                                                value: '2'
                                                            },
                                                            {
                                                                label: 'לאומית',
                                                                value: '2'
                                                            },
                                                            {
                                                                label: 'מכבי',
                                                                value: '2'
                                                            }
                                                        ]}
                                                    />
                                                </div>
                                                <div className='error-message'>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`parameter-item`}>
                                            <div className="field">
                                                <div className="title">
                                                    שם פרטי
                                                </div>
                                                <div className="value">
                                                    <input type='text' value={''} />
                                                </div>
                                                <div className='error-message'>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`parameter-item`}>
                                            <div className="field">
                                                <div className="title">
                                                    מין
                                                </div>
                                                <div className="value">
                                                    <Select
                                                        value={'ספק שירות'}
                                                        style={{ width: '100%' }}
                                                        options={[
                                                            {
                                                                label: 'זכר',
                                                                value: '1'
                                                            },
                                                            {
                                                                label: 'נקבה',
                                                                value: '2'
                                                            }
                                                        ]}
                                                    />
                                                </div>
                                                <div className='error-message'>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`parameter-item`}>
                                            <div className="field">
                                                <div className="title">
                                                    מס' דרכון
                                                </div>
                                                <div className="value">
                                                    <input type='text' value={''} />
                                                </div>
                                                <div className='error-message'>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`parameter-item`}>
                                            <div className="field">
                                                <div className="title">
                                                    ארץ מוצא
                                                </div>
                                                <div className="value">
                                                    <input type='text' value={''} />
                                                </div>
                                                <div className='error-message'>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`parameter-item`}>
                                            <div className="field">
                                                <div className="title">
                                                    מספר מבוטח
                                                </div>
                                                <div className="value">
                                                    <input type='text' value={''} />
                                                </div>
                                                <div className='error-message'>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`parameter-item`}>
                                            <div className="field">
                                                <div className="title">
                                                    שם משפחה
                                                </div>
                                                <div className="value">
                                                    <input type='text' value={''} />
                                                </div>
                                                <div className='error-message'>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`parameter-item`}>
                                            <div className="field">
                                                <div className="title">
                                                    טלפון נייד
                                                </div>
                                                <div className="value">
                                                    <input type='text' value={''} />
                                                </div>
                                                <div className='error-message'>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-row">
                                        <div className={`parameter-item`}>
                                            <div className="field">
                                                <div className="title">
                                                    תוקף דרכון
                                                </div>
                                                <div className="value">
                                                    <CompDatePicker onChange={(date: any) => { }} value={null} />
                                                </div>
                                                <div className='error-message'>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`parameter-item`}>
                                            <div className="field">
                                                <div className="title">
                                                    ת. כניסה לארץ
                                                </div>
                                                <div className="value">
                                                    <CompDatePicker onChange={(date: any) => { }} value={null} />
                                                </div>
                                                <div className='error-message'>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`parameter-item`}>

                                        </div>
                                        <div className={`parameter-item`}>

                                        </div>
                                        <div className={`parameter-item`}>

                                        </div>
                                        <div className={`parameter-item`}>

                                        </div>
                                        <div className={`parameter-item`}>

                                        </div>
                                        <div className={`parameter-item`}>

                                        </div>
                                    </div>
                                </div>

                                <PaymentAndBankDetails
                                    policy={policy}
                                    setPremia={setPremia}
                                    onAdditionalDetailsChange={onAdditionalDetailsChange}
                                    collectionMethodtype={collectionMethodtype}
                                    allBanks={allBanks}
                                />

                                <div className="parameter-row">
                                    <div className="tab-content-title section-title">
                                        שעבוד
                                    </div>
                                </div>
                                <div className="parameter-row">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                                סוג שעבוד
                                            </div>
                                            <div className="value">

                                                <select id="involvedPartyType" value={policy.policyAdditionDetails && policy.policyAdditionDetails.involvedPartyType ?
                                                    policy.policyAdditionDetails.involvedPartyType : ''}
                                                    onChange={(e) => onAdditionalDetailsChange("involvedPartyType", e.target.value)}>
                                                    <option value="" >בחר</option>
                                                    <option value="0" >בנק</option>
                                                    <option value="1" >חברה</option>
                                                </select>
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>

                                    {policy.policyAdditionDetails && policy.policyAdditionDetails.involvedPartyType == "0" ?
                                        <>
                                            <div className={`parameter-item`}>
                                                <div className="field">
                                                    <div className="title">
                                                        משעבד
                                                    </div>
                                                    <div className="value">

                                                        <select id="involvedBank" value={policy.policyAdditionDetails && policy.policyAdditionDetails.involvedBank}
                                                            onChange={(e) => onAdditionalDetailsChange("involvedBank", e.target.value)}>
                                                            <option value="">בחר</option>
                                                            {allBanks.map((bank: any, index: number) => (
                                                                <option key={index} value={bank.BankName}>
                                                                    {bank.BankName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className='error-message'>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`parameter-item`}>
                                                <div className="field">
                                                    <div className="title">
                                                        סניף וכתובת
                                                    </div>
                                                    <div className="value">
                                                        {/* <input type='text' value={policy.policyAdditionDetails.involvedBankBranch}
                                                    onChange={(e) => onAdditionalDetailsChange('involvedBankBranch', e.target.value)}
                                                /> */}
                                                        <select id="involvedBankBranch" value={policy?.policyAdditionDetails?.involvedBankBranch && policy?.policyAdditionDetails?.involvedBankBranch.split(',')[0] || ""}
                                                            onChange={(e) => onAdditionalDetailsChange("involvedBankBranch", e.target.value)}>
                                                            <option value="">בחר</option>
                                                            {allBanks.find((bank: any) => bank.BankName === policy?.policyAdditionDetails?.involvedBank) !== undefined &&
                                                                allBanks.find((bank: any) => bank.BankName === policy?.policyAdditionDetails?.involvedBank)?.branchCode.map((item: any, index: number) => (

                                                                    <option key={index} value={item.Branch_Code}>
                                                                        {"סניף:" + item.Branch_Code + "-  כתובת:" + item.Branch_Address}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                    <div className='error-message'>
                                                    </div>
                                                </div>
                                            </div>
                                        </> :
                                        policy.policyAdditionDetails && policy.policyAdditionDetails.involvedPartyType == "1" ?
                                            <>
                                                <div className={`parameter-item`}>
                                                    <div className="field">
                                                        <div className="title">
                                                            משעבד
                                                        </div>
                                                        <div className="value">
                                                            <input type='text' value={policy.policyAdditionDetails.involvedName}
                                                                onChange={(e) => onAdditionalDetailsChange('involvedName', e.target.value)} />
                                                        </div>
                                                        <div className='error-message'>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`parameter-item`}>
                                                    <div className="field">
                                                        <div className="title">
                                                            רחוב ומספר
                                                        </div>
                                                        <div className="value">
                                                            <input type='text' value={policy.policyAdditionDetails.involvedAddress}
                                                                onChange={(e) => onAdditionalDetailsChange('involvedAddress', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className='error-message'>
                                                        </div>
                                                    </div>
                                                </div>

                                            </> : <></>}

                                </div>
                                <div className="parameter-row">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                                הוקם ע"י
                                            </div>
                                            <div className="value">
                                                {policy && policy.creatorUserId ? getCreatorIfo(policy.creatorUserId) : ''}
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                                תאריך עדכון
                                            </div>
                                            <div className="value">
                                                {policy.policyAdditionDetails && policy.policyAdditionDetails.updatedDate ? new Date(policy.policyAdditionDetails.updatedDate).toLocaleDateString('he-IL') : new Date().toLocaleDateString('he-IL')}
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`parameter-row single-item`}>
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                                הערות
                                            </div>
                                            <div className="value">
                                                <PolicyInput type='text'
                                                    value={policy.comments ?
                                                        policy.comments : ''}
                                                    onChange={(e) => onChangePrimeryDetails('comments', e.target.value)}
                                                    style={{ marginLeft: '10px', width: '100%' }}
                                                />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="popup-footer">
                            <button className="button white blue-border" onClick={(e: any) => closePopup()}>
                                ביטול
                            </button>
                            <button className="button blue" onClick={(e: any) => savePolicy()}>
                                שמירה
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
export default ClientPolicyEditPopup;